import { createEvent } from 'effector'

import { model as popupModel } from '~/entities/info-popup'

export const init = createEvent()

popupModel.$unlockedId.reset(init)
